import { render } from "./EventsDialog.vue?vue&type=template&id=d4d99ca6"
import script from "./EventsDialog.vue?vue&type=script&lang=js"
export * from "./EventsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__